// chatService.js
import { saveChatAssign } from "../../redux/actions/chat";

export const updateChatAssignment = (dispatch, {
  channelUrl,
  userInfo,
  patientId,
  status
}) => {
  if (!channelUrl || !userInfo?.id) {
    console.warn("Missing parameters for updateChatAssignment");
    return;
  }

  const reqData = {
    sendbird_channel_url: channelUrl,
    assign_user_id: userInfo.id,
    assign_user_type:
      userInfo?.doctor_login?.user_type === null
        ? "provider"
        : "nonprovider",
    site_type: "careappweb",
    patient_id: patientId,
    status: status,
  };

  dispatch(saveChatAssign({ data: reqData }));
};
